import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiSearch, FiGrid, FiList } from 'react-icons/fi';

const CATEGORIES = ['All', 'Phishing Education', 'Authentication', 'Physical Security', 'Compliance Training', 'Policy Acknowledgement'];
const FORMATS = ['All', 'Video', 'Interactive', 'Course', 'Micro-learning', 'Quiz'];
const STATUSES = ['All', 'Active', 'Draft', 'Archived'];
const DIFFICULTIES = ['All', 'Beginner', 'Intermediate', 'Advanced'];
const COMPLIANCE = ['All', 'NIST CSF', 'ISO 27001', 'SOC 2', 'GDPR', 'HIPAA', 'CCPA'];
const LANGUAGES = ['All', 'English', 'Español'];

const Sel = ({ value, onChange, options }) => (
  <select
    value={value}
    onChange={e => onChange(e.target.value)}
    className="px-3 py-2 bg-white border border-slate-200 rounded-lg text-xs font-medium text-slate-600 focus:outline-none focus:border-blue-500 cursor-pointer"
  >
    {options.map(o => <option key={o}>{o}</option>)}
  </select>
);

const LibraryFilters = ({ filters, setFilters, view, setView }) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 space-y-3">
    <div className="flex gap-3 flex-col sm:flex-row">
      <div className="relative flex-1">
        <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          value={filters.search}
          onChange={e => setFilters(f => ({ ...f, search: e.target.value }))}
          placeholder="Search modules by title, category, compliance…"
          className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 focus:bg-white"
        />
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => setView('grid')}
          className={`p-2 rounded-lg border transition-colors ${view === 'grid' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-500 border-slate-200 hover:bg-slate-50'}`}
        >
          <SafeIcon icon={FiGrid} />
        </button>
        <button
          onClick={() => setView('table')}
          className={`p-2 rounded-lg border transition-colors ${view === 'table' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-500 border-slate-200 hover:bg-slate-50'}`}
        >
          <SafeIcon icon={FiList} />
        </button>
      </div>
    </div>
    <div className="flex flex-wrap gap-2">
      <Sel value={filters.category} onChange={v => setFilters(f => ({ ...f, category: v }))} options={CATEGORIES} />
      <Sel value={filters.format} onChange={v => setFilters(f => ({ ...f, format: v }))} options={FORMATS} />
      <Sel value={filters.status} onChange={v => setFilters(f => ({ ...f, status: v }))} options={STATUSES} />
      <Sel value={filters.difficulty} onChange={v => setFilters(f => ({ ...f, difficulty: v }))} options={DIFFICULTIES} />
      <Sel value={filters.compliance} onChange={v => setFilters(f => ({ ...f, compliance: v }))} options={COMPLIANCE} />
      <Sel value={filters.language} onChange={v => setFilters(f => ({ ...f, language: v }))} options={LANGUAGES} />
      {Object.entries(filters).some(([k, v]) => v !== 'All' && v !== '') && (
        <button
          onClick={() => setFilters({ search: '', category: 'All', format: 'All', status: 'All', difficulty: 'All', compliance: 'All', language: 'All' })}
          className="text-xs text-blue-600 hover:underline font-medium px-2"
        >
          Clear filters
        </button>
      )}
    </div>
  </div>
);

export default LibraryFilters;